// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2vuWv","options":"AnswerScale_options__2Ir2z","selected":"AnswerScale_selected__15rvZ"};